import React, { useState, useEffect } from 'react';
import { mockData } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';
import { useTranslate } from '../hooks/useTranslate';

const Welcome = () => {
  const [htmlContent, setHtmlContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const { currentLanguage } = useLanguage();
  
  // Traduire le contenu HTML
  const { translatedText: translatedContent } = useTranslate(htmlContent || "");

  useEffect(() => {
    // Récupérer le contenu depuis l'API
    const fetchWelcomeContent = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site/pages/home-welcome`);
        if (response.ok) {
          const data = await response.json();
          if (data.content) {
            // Utiliser directement le HTML complet depuis l'API
            setHtmlContent(data.content);
          }
        }
      } catch (error) {
        console.error('Erreur chargement welcome content:', error);
        // En cas d'erreur, ne rien afficher ou utiliser un fallback
      } finally {
        setLoading(false);
      }
    };

    fetchWelcomeContent();
  }, []);

  if (loading) {
    return (
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <div className="animate-pulse">
              <div className="h-8 bg-gray-200 rounded w-3/4 mx-auto mb-4"></div>
              <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
              <div className="h-4 bg-gray-200 rounded w-5/6 mx-auto"></div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Si on a du contenu HTML depuis l'API, l'afficher directement
  if (htmlContent) {
    // Afficher le contenu traduit pour toutes les langues sauf français
    // Si la traduction est en cours ou vide, afficher un placeholder
    if (currentLanguage !== 'fr') {
      // Attendre que la traduction soit chargée
      if (!translatedContent) {
        return (
          <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="max-w-4xl mx-auto text-center">
                <div className="animate-pulse">
                  <div className="h-8 bg-gray-200 rounded w-3/4 mx-auto mb-4"></div>
                  <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded w-5/6 mx-auto"></div>
                </div>
              </div>
            </div>
          </section>
        );
      }
      return <div dangerouslySetInnerHTML={{ __html: translatedContent }} />;
    }
    
    // Pour le français, afficher directement l'original
    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
  }

  // Fallback: afficher le contenu par défaut si pas de contenu depuis l'API
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h2 
            className="text-4xl font-bold text-[#2c3e50] mb-8 text-center"
            style={{ fontFamily: '"Lora", serif' }}
          >
            {mockData.welcome.title}
          </h2>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-[#5a6c7d] leading-relaxed" style={{ fontFamily: '"Lora", serif', fontSize: '17px' }}>
              {mockData.welcome.content}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;